import { create } from 'zustand';

export interface NowState {
  now: number;
  setNow: (now: number) => void;
}

const useNowState = create<NowState>((set) => ({
  now: Date.now(),
  setNow: (now) => set((state) => ({ ...state, now })),
}));

setInterval(() => {
  const { setNow } = useNowState.getState();
  setNow(Date.now());
}, 500);

export const useNow = () => useNowState((state) => state.now);
